import React, {Component} from 'react'

class Button extends Component {
  /*
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  class_name: PropTypes.string.isRequired,
  value: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
  placeHolder: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired

*/
  constructor(props) {
    super(props);
    this.state={
      activeLoader: true,
      disabled:(this.props.disabled)?this.props.disabled:false
    }
    this.onClick = this.onClick.bind(this);
  }

  UNSAFE_componentWillReceiveProps(newProps){
    if(JSON.stringify(newProps) !== JSON.stringify(this.props)){
      this.setState({
        disabled:(newProps.disabled)?newProps.disabled:false
      })
    }
  }

  onClick(event){
    var sendObj;
    if(this.props.onClick !== undefined)
      this.props.onClick(event);
  }

  render() {
    if(this.state.disabled)

      return (
        <button id={(this.props.id)?this.props.id:null} disabled={this.state.disabled} onClick={this.onClick} className={(this.props.className)?this.props.className:""}  type={(this.props.type)?this.props.type:"button"} >
          {this.props.text}

        </button>
      );
    else
      return (
        <button id={(this.props.id)?this.props.id:null} onClick={this.onClick} className={(this.props.className)?this.props.className:""}  type={(this.props.type)?this.props.type:"button"} >
          {this.props.text}

        </button>
      );
  }
}

export default Button
